
import { createStore, applyMiddleware, Middleware } from 'redux';
import logger from 'redux-logger';
import RootReducer from './store/reducers';

const typedLogger = logger as unknown as Middleware; 

export const store = createStore(RootReducer, applyMiddleware(typedLogger));
